// App.js
import React, { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import RoutesConfig from "./Route/Route";

const App = () => {
  return (
    <Router>
      <Suspense fallback={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}><ThreeDots color="#EA6723" height={80} width={80} /></div>}>
        <RoutesConfig />
      </Suspense>
    </Router>
  );
};

export default App;
